import { useMutation } from '@apollo/client';

import DELETE_PARTICIPATION_INPUT from '@graphql/deleteParticipationInput.graphql';

export const useDeleteParticipationInput = () => {
  const [deleteFunction, { loading, error }] = useMutation(DELETE_PARTICIPATION_INPUT);

  const deleteParticipationInput = (input) => {
    return deleteFunction({ variables: { input } });
  };

  return [deleteParticipationInput, { loading, error }];
};
